// Test IDs for the site (landing + shared shell).

export const SITE = {
  // Header
  headerLogo: "site-header-logo",
  headerNav: "site-header-nav",
  headerNavLink: "site-header-nav-link", // suffix with kebab route
  headerGetAppBtn: "site-header-get-app-btn",
  headerMobileToggle: "site-header-mobile-toggle",
  headerMobileMenu: "site-header-mobile-menu",

  // Hero
  heroSection: "site-hero-section",
  heroTagline: "site-hero-tagline",
  heroGetAppBtn: "site-hero-get-app-btn",
  heroDemoBtn: "site-hero-demo-btn",
  heroAppStoreBadge: "site-hero-app-store-badge",
  heroPlayStoreBadge: "site-hero-play-store-badge",
  heroEmailInput: "site-hero-email-input",
  heroEmailSubmit: "site-hero-email-submit",

  // Demo video
  demoSection: "site-demo-section",
  demoPlayBtn: "site-demo-play-btn",
  demoNotice: "site-demo-notice",

  // Three moments
  momentsSection: "site-moments-section",
  momentAccused: "site-moment-accused",
  momentMissing: "site-moment-missing",
  momentAltercations: "site-moment-altercations",

  // How it works
  howSection: "site-how-section",
  howStep1: "site-how-step-1",
  howStep2: "site-how-step-2",
  howStep3: "site-how-step-3",

  // Trust strip
  trustStrip: "site-trust-strip",

  // Pricing teaser
  pricingTeaser: "site-pricing-teaser",
  pricingTierFree: "site-pricing-tier-free",
  pricingTierPlus: "site-pricing-tier-plus",
  pricingTierPro: "site-pricing-tier-pro",
  pricingFullLink: "site-pricing-full-link",

  // Per-page identifiers
  pricingPage: "page-pricing",
  pricingTable: "page-pricing-table",
  pricingCta: "page-pricing-cta",
  securityPage: "page-security",
  securityCanTable: "page-security-can-table",
  securitySealSteps: "page-security-seal-steps",
  securityYours: "page-security-yours",
  securityStalking: "page-security-stalking",
  securityDeepVault: "page-security-deep-vault",
  securityLimitations: "page-security-limitations",
  securityConsent: "page-security-consent",
  securityPatent: "page-security-patent",
  undertakingPage: "page-undertaking",
  undertakingDocument: "page-undertaking-document",
  undertakingClauses: "page-undertaking-clauses",
  undertakingDraftBanner: "page-undertaking-draft-banner",
  undertakingWhyWeAsk: "page-undertaking-why-we-ask",
  undertakingConsequences: "page-undertaking-consequences",
  undertakingCta: "page-undertaking-cta",
  faqPage: "page-faq",
  faqAccordion: "page-faq-accordion",
  faqSearchInput: "page-faq-search-input",
  faqEmpty: "page-faq-empty",
  faqItem: "page-faq-item",
  storiesPage: "page-stories",
  storiesCard: "page-stories-card",
  storiesShare: "page-stories-share",
  privacyPage: "page-privacy",
  termsPage: "page-terms",
  pageBadgeBand: "page-badge-band",

  // Situation pages (shared shell)
  situationPage: "situation-page",
  situationNarrative: "situation-narrative",
  situationCovers: "situation-covers",
  situationSubsection: "situation-subsection",
  situationCrossLinks: "situation-cross-links",
  situationFinalEmailInput: "situation-final-email-input",
  situationFinalEmailSubmit: "situation-final-email-submit",
  situationFinalSuccess: "situation-final-success",
  situationFinalError: "situation-final-error",

  // Final CTA
  finalCtaSection: "site-final-cta-section",
  finalCtaAppStoreBadge: "site-final-cta-app-store-badge",
  finalCtaPlayStoreBadge: "site-final-cta-play-store-badge",
  finalCtaEmailInput: "site-final-cta-email-input",
  finalCtaEmailSubmit: "site-final-cta-email-submit",
  finalCtaSuccess: "site-final-cta-success",
  finalCtaError: "site-final-cta-error",

  // Mid-page badge band
  midBandSection: "site-mid-band-section",
  midAppStoreBadge: "site-mid-app-store-badge",
  midPlayStoreBadge: "site-mid-play-store-badge",

  // Footer
  footer: "site-footer",
  footerAppStoreBadge: "site-footer-app-store-badge",
  footerPlayStoreBadge: "site-footer-play-store-badge",
  footerEmail: "site-footer-email",
  footerPhone: "site-footer-phone",
  footerDisclaimer: "site-footer-disclaimer",
  footerOwnership: "site-footer-ownership",

  // Get-the-app modal
  modalRoot: "get-app-modal",
  modalAppStoreBadge: "get-app-modal-app-store-badge",
  modalPlayStoreBadge: "get-app-modal-play-store-badge",
  modalEmailInput: "get-app-modal-email-input",
  modalEmailSubmit: "get-app-modal-email-submit",
  modalClose: "get-app-modal-close",
  modalSuccess: "get-app-modal-success",
  modalError: "get-app-modal-error",
};

export const HOME = {
};
